import zoomLib from '@/feature/zoom/zoom.lib';
import vtexLib from '@/feature/vtex/vtex.lib';
import precodeLib from '@/feature/precode/precode.lib';
import cursologyLib from '@/feature/cursology/cursology.lib';
import genLib from '@/feature/gen/gen.lib';
import nuvemshopLib from '@/feature/nuvemshop/nuvemshop.lib';

const eventHandlers = {
  zoom: zoomLib.preQualifyEventHandler,
  vtex: vtexLib.preQualifyEventHandler,
  precode: precodeLib.preQualifyEventHandler,
  cursology: cursologyLib.preQualifyEventHandler,
  gen: genLib.preQualifyEventHandler,
  nuvemshop: nuvemshopLib.preQualifyEventHandler,
};

export default {
  getContextVariables(context) {
    return {
      eventHandler: eventHandlers[context],
    };
  },
};
